<template>
  <v-dialog v-model="open_modal" width="500" scrollable>
      <v-card>
        <v-card-title class="headline">Delete client</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Are you sure to eliminate the selected client?</p>
          <p><strong>{{ client.name }}</strong></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="open_modal = false">NO</v-btn>
          <v-btn color="red" @click="destroyContact">YES</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {};
  },
  computed: {
    open_modal: {
      set (val) {
        this.$store.dispatch('setOpenModalClientDestroy', val);
      },
      get () {
        return this.$store.state.client.open_modal_client_destroy;
      }
    },
    ...mapGetters(['loading', 'open_modal_delete_contact', 'client', 'clients'])
  },
  methods: {
    destroyContact () {
      this.$store.dispatch('setLoading', true);
      const url = `/client/${this.client.id}/delete`;
      window.axios.delete(url).then(response => {
        const temp = this.clients.filter(client => {
          return client.id !== this.client.id;
        });
        this.$store.dispatch('setClients', temp);
        this.$store.dispatch('setLoading', false);
        this.open_modal = false;
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'success',
          text: 'Customer removed correctly.'
        });
      });
    }
  }
};
</script>
<style>
  .text-right{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/clients/ModalDelete.vue